import {
  SupplyIntelBrandRowSchema,
  SupplyIntelWarehouseSchema,
} from "@redotech/redo-inventory-common/supply-intel/brand-list";
import {
  SupplyIntelBrandProductRowSchema,
  SupplyIntelTopProductSchema,
} from "@redotech/redo-inventory-common/supply-intel/brand-products";
import { SupplyIntelBrandProductSortKey } from "@redotech/redo-inventory-common/supply-intel/brand-view";
import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import { createTableSortSchema } from "@redotech/redo-views-common/table";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

/** One brand's returned units on Redo's shelves, rolled up by store product, from the cached snapshot. */
export const getSupplyIntelBrandProducts = unaryRpc({
  name: "getSupplyIntelBrandProducts" as const,
  input: z.object({
    accountId: z.string().regex(/^\d{1,19}$/),
    search: z.string().optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
    sort: createTableSortSchema(
      z.enum(SupplyIntelBrandProductSortKey),
    ).optional(),
    page: z.number().int().min(0).default(0),
    pageSize: z.number().int().min(1).max(500).default(50),
  }),
  output: z.object({
    /** Null until the brand's rows are available. */
    page: z
      .object({
        rows: z.array(SupplyIntelBrandProductRowSchema),
        totalCount: z.number(),
        /** The brand's list row, rolled up over every row that matches the search and filters. */
        summary: SupplyIntelBrandRowSchema,
        /** The products with the most store value leaving the brand's store, over the matching rows. */
        topProducts: z.array(SupplyIntelTopProductSchema),
        /** Every warehouse the brand has units in, for the warehouse filter. */
        warehouses: z.array(SupplyIntelWarehouseSchema),
        /** Every category path the brand has units in, for the category filter. */
        categories: z.array(z.string()),
        dataAsOf: z.date(),
        configVersion: z.string(),
        /** The snapshot hit its row limit, so some units are missing. */
        truncated: z.boolean(),
      })
      .nullable(),
    /** When the build in progress started, if one is running. */
    buildStartedAt: z.date().nullable(),
  }),
});
